import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
//UI
import { FaAddressBook, FaBookOpen, FaFileAlt, FaFileExcel, FaLevelUpAlt, FaLifeRing, FaUsers } from 'react-icons/fa';
import BtnDashboard from '../buttons/BtnDashboard';
//RESOURCERS
import { useCollapsed, useCollapsedLower, useToolbarStore } from '../../store/VitalStore';
import { FaBuilding } from 'react-icons/fa6';
import { Collapse } from "react-collapse";
import ReportList from "./ReportList";
import students from '../../assets/icons/students.svg'
import paralles from '../../assets/icons/paralles.svg'
import files from '../../assets/icons/files.svg'
import events from '../../assets/icons/events.svg'
import courses from '../../assets/icons/courses.svg'
import cupo from '../../assets/icons/cupo.svg'
import sections from '../../assets/icons/sections.svg'
import politics from '../../assets/icons/politics.svg'
import contracts from '../../assets/icons/contracts.svg'
import forms from '../../assets/icons/forms.svg'
import ContractList from "./ContractList";

const PanelList = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const { t } = useTranslation();
    const { isToolbarOpen, closeToolbar } = useToolbarStore((state) => state);

    const { isCollapsed, openCollapsed, closeCollapsed } = useCollapsed(
        (state) => state
    );

    const { isCollapsedLower, openCollapsedLower, closeCollapsedLower } = useCollapsedLower(
        (state) => state
    );

    const user = JSON.parse(localStorage.getItem("userInfo"));

    return (
        <div className='w-[100%]'>
            {['Administrador', 'Secretaria'].includes(user.role) ?
                <>
                    <div className='pl-2 text-[10px] font-semibold uppercase text-start text-sky-700'>Catalogos</div>
                    <li
                        onClick={(e) => { navigate('/panel/sections'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/sections') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={sections} className='w-6 h-6' />
                            <p>{t("Secciones")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/courses'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/courses') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={courses} className='w-6 h-6' />
                            <p>{t("Cursos")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/parallels'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/parallels') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={paralles} className='w-6 h-6' />
                            <p>{t("Paralelos")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/events'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/events') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={events} className='w-6 h-6' />
                            <p>{t("Eventos")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/students'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/students') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={students} className='w-6 h-6' />
                            <p>{t("Estudiantes")}</p>
                        </BtnDashboard>
                    </li>
                </> : ''
            }
            {['Administrador'].includes(user.role) ?
                <>
                    <div className='pl-2 text-[10px] font-semibold uppercase text-start text-sky-700'>Procesos</div>
                    <li
                        onClick={(e) => { navigate('/panel/privacy_policy'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/privacy_policy') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={politics} className='w-6 h-6' />
                            <p>{t("Politica de privacidad")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/contracts'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/contracts') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={contracts} className='w-6 h-6' />
                            <p>{t("Contratos")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/documentations'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/documentations') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={files} className='w-6 h-6' />
                            <p>{t("Documentación")}</p>
                        </BtnDashboard>
                    </li>
                    <li
                        onClick={(e) => { navigate('/panel/forms'); closeToolbar(); }}
                        className={`w-full ${location.pathname.startsWith('/panel/forms') ? 'active' : ''}`}>
                        <BtnDashboard>
                            <img src={forms} className='w-6 h-6' />
                            <p>{t("Formularios")}</p>
                        </BtnDashboard>
                    </li>
                </> : ''
            }
            {['Administrador', 'Administrativo'].includes(user.role) ?
                <>
                    <div className='pl-2 text-[10px] font-semibold uppercase text-start text-sky-700'>Reporteria</div>
                    <li className={`w-full group mt-[-25px]`}>
                        <input
                            className="appearance-none"
                            type="checkbox"
                            id="cupos"
                            onChange={(e) => {
                                e.target.checked ? openCollapsed() : closeCollapsed();
                            }}
                        />
                        <label htmlFor="cupos">
                            <BtnDashboard>
                                <img src={cupo} className='w-6 h-6' />
                                <div className="flex w-[100%] items-center justify-between  gap-2">
                                    <p>{"Cupos"}</p>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        className={`w-3 h-3 transition-all ${isCollapsed ? 'rotate-90' : ''
                                            }`}
                                    >
                                        <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                                    </svg>
                                </div>
                            </BtnDashboard>
                        </label>
                        <Collapse isOpened={isCollapsed}>
                            <ReportList />
                        </Collapse>
                    </li>
                </>
                : ''}
            {['Administrador', 'Administrativo', 'Médico'].includes(user.role) ?

                <li className={`w-full group mt-[-25px]`}>
                    <input
                        className="appearance-none"
                        type="checkbox"
                        id="proceso"
                        onChange={(e) => {
                            e.target.checked ? openCollapsedLower() : closeCollapsedLower();
                        }}
                    />
                    <label htmlFor="proceso">
                        <BtnDashboard>
                            <img src={politics} className='w-6 h-6' />
                            <div className="flex w-[100%] items-center justify-between  gap-2">
                                <p>{"Proceso Matriculacion"}</p>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    className={`w-3 h-3 transition-all ${isCollapsedLower ? 'rotate-90' : ''
                                        }`}
                                >
                                    <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                                </svg>
                            </div>
                        </BtnDashboard>
                    </label>
                    <Collapse isOpened={isCollapsedLower}>
                        <ContractList />
                    </Collapse>
                </li>
                : ' '
            }
            {['Administrador', 'Administrativo', 'Médico'].includes(user.role) ?

                <li
                    onClick={(e) => { navigate('/panel/reports/transport'); closeToolbar(); }}
                    className={`w-full ${location.pathname.startsWith('/panel/reports/transport') ? 'active' : ''}`}>
                    <BtnDashboard>
                        <img src={files} className='w-6 h-6' />
                        <p>{t("Transporte")}</p>
                    </BtnDashboard>
                </li>
                : ' '
            }
        </div>
    );
};

export default PanelList;